<template>
  <div id="app">
    <!-- 头部 -->
    <my-header />
    <!-- 路由页面 -->
    <router-view />
    <!-- 底部 -->
    <my-footer />
  </div>
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    meta: [{
      name: 'keyWords', // 页面关键词 keywords
      content: '席媒,无纸化会议系统,无纸化会议,平板无纸化,无纸化,桌牌,电子桌牌,无纸化多媒体会议系统,液晶电子桌牌,会议桌牌'
    }, {
      name: 'description', // 页面描述
      content: '席媒控股多年研发无纸化多媒体智能会议系统电子桌牌，专业定制无纸化会议室，企业会议高效安全保密，客户体验极佳，彰显企业实力。电话:0571-88846606'
    }, {
      name: 'author',
      content: '席媒科技'
    }, {
      name: 'copyright',
      content: '席媒科技'
    }
    ]
  }
}
</script>

<style lang="scss" >
</style>



// WEBPACK FOOTER //
// src/App.vue